import { APP_URL } from '@/config'

export default {
  default: {
    twitter: {
      cardType: 'summary_large_image',
      site: '@neatcompany',
      handle: '@neatcompany',
    },
    facebook: {
      appId: '213623165805968',
    },
    openGraph: {
      locale: 'en_US',
      site_name: 'The Neat Company',
    },
    jsonLD: {
      organization: {
        id: `${APP_URL}/#organization`,
        name: 'The Neat Company',
        url: APP_URL,
        sameAs: [
          'https://www.facebook.com/NeatCompany/',
          'https://www.linkedin.com/company/the-neat-company_2/',
        ],
        logo: {
          '@type': 'ImageObject',
          '@id': `${APP_URL}/#logo`,
          inLanguage: 'en-US',
          url: '',
          contentUrl: '',
          caption: 'The Neat Company',
        },
        image: { '@id': `${APP_URL}/#logo` },
      },
      website: {
        id: `${APP_URL}/#website`,
        url: APP_URL,
        name: 'The Neat Company',
        description: '',
        publisher: { '@id': `${APP_URL}/#organization` },
        potentialAction: [{ '@type': 'SearchAction', target: { '@type': 'EntryPoint', urlTemplate: `${APP_URL}/?s={search_term_string}` }, 'query-input': 'required name=search_term_string' }],
        inLanguage: 'en-US',
      },
    },
  },
  404: { seo: {} },
  neatFeatures: {
    title: 'Smart Receipt Organizer & Paperless Document Management',
    description: 'Neat\'s Smart Receipt Organizer and Paperless Document Management simplify organization with efficient data extraction and search.',
    canonical: `${APP_URL}/neat-features/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/neat-features/`,
      type: 'article',
      article: {
        modifiedTime: '2023-06-14T00:51:25+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/neat-features/#webpage`,
        url: `${APP_URL}/neat-features/`,
        name: 'Smart Receipt Organizer & Paperless Document Management',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2023-06-14T00:51:25+00:00',
        dateModified: '2023-06-14T00:51:25+00:00',
        description: 'Neat\'s Smart Receipt Organizer and Paperless Document Management simplify organization with efficient data extraction and search.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Neat Features', item: `${APP_URL}/neat-features/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/neat-features/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/neat-features/#primaryimage' },
      },
    },
    uri: '/neat-features/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '4 minutes',
      },
    ],
  },
  neatHome: {
    title: 'NeatHome',
    description: '',
    canonical: `${APP_URL}/neathome/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/neathome/`,
      type: 'article',
      article: {
        modifiedTime: '2023-06-14T00:51:25+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/neathome/#webpage`,
        url: `${APP_URL}/neathome/`,
        name: 'NeatHome',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2024-03-16T00:51:25+00:00',
        dateModified: '2024-03-16T00:51:25+00:00',
        description: '',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Neat Home', item: `${APP_URL}/neathome/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/neathome/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/neathome/#primaryimage' },
      },
    },
    uri: '/neathome/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '4 minutes',
      },
    ],
  },
  neatVsAutoentry: {
    title: 'Compare Neat Vs AutoEntry',
    description: 'Learn about the comparisons of two apps, Neat & AutoEntry, that both can scan and track receipts, invoices & bank statements.',
    canonical: `${APP_URL}/neat-vs-autoentry/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/neat-vs-autoentry/`,
      type: 'article',
      article: {
        modifiedTime: '2023-06-14T00:51:25+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/neat-vs-autoentry/#webpage`,
        url: `${APP_URL}/neat-vs-autoentry/`,
        name: 'Compare Neat Vs AutoEntry',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2024-08-18T00:51:25+00:00',
        dateModified: '2024-08-18T00:51:25+00:00',
        description: 'Learn about the comparisons of two apps, Neat & AutoEntry, that both can scan and track receipts, invoices & bank statements.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Neat Vs AutoEntry', item: `${APP_URL}/neat-vs-autoentry/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/neat-vs-autoentry/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/neat-vs-autoentry/#primaryimage' },
      },
    },
    uri: '/neat-vs-autoentry/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '4 minutes',
      },
    ],
  },
  neatVsShoeboxed: {
    title: 'Compare Neat Vs Shoeboxed',
    description: 'Learn about the comparisons of two apps, Neat & Shoeboxed, that both can scan and track receipts, invoices & bank statements.',
    canonical: `${APP_URL}/neat-vs-shoeboxed/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/neat-vs-shoeboxed/`,
      type: 'article',
      article: {
        modifiedTime: '2024-11-06T00:51:25+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/neat-vs-shoeboxed/#webpage`,
        url: `${APP_URL}/neat-vs-shoeboxed/`,
        name: 'Compare Neat Vs Shoeboxed',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2024-11-06T00:51:25+00:00',
        dateModified: '2024-11-06T00:51:25+00:00',
        description: 'Learn about the comparisons of two apps, Neat & Shoeboxed, that both can scan and track receipts, invoices & bank statements.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Neat Vs Shoeboxed', item: `${APP_URL}/neat-vs-shoeboxed/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/neat-vs-shoeboxed/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/neat-vs-shoeboxed/#primaryimage' },
      },
    },
    uri: '/neat-vs-shoeboxed/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '4 minutes',
      },
    ],
  },
  neatVsFyle: {
    title: 'Compare Neat Vs Fyle',
    description: 'Learn about the comparisons of two apps, Neat & Fyle, that both can scan and track receipts, invoices & bank statements.',
    canonical: `${APP_URL}/neat-vs-fyle/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/neat-vs-fyle/`,
      type: 'article',
      article: {
        modifiedTime: '2024-11-06T00:51:25+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/neat-vs-fyle/#webpage`,
        url: `${APP_URL}/neat-vs-fyle/`,
        name: 'Compare Neat Vs Fyle',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2024-11-06T00:51:25+00:00',
        dateModified: '2024-11-06T00:51:25+00:00',
        description: 'Learn about the comparisons of two apps, Neat & Fyle, that both can scan and track receipts, invoices & bank statements.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Neat Vs Fyle', item: `${APP_URL}/neat-vs-fyle/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/neat-vs-fyle/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/neat-vs-fyle/#primaryimage' },
      },
    },
    uri: '/neat-vs-fyle/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '4 minutes',
      },
    ],
  },
  scansnapCloud: {
    title: 'Scansnap Cloud',
    description: '',
    canonical: `${APP_URL}/scansnap-cloud/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/scansnap-cloud/`,
      type: 'article',
      article: {
        modifiedTime: '2023-06-14T00:51:25+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/scansnap-cloud/#webpage`,
        url: `${APP_URL}/scansnap-cloud/`,
        name: 'Scansnap Cloud',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2024-03-16T00:51:25+00:00',
        dateModified: '2024-03-16T00:51:25+00:00',
        description: '',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Scansnap Cloud', item: `${APP_URL}/scansnap-cloud/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/scansnap-cloud/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/scansnap-cloud/#primaryimage' },
      },
    },
    uri: '/scansnap-cloud/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '4 minutes',
      },
    ],
  },
  accountants: {
    title: 'Automated Bookkeeping Software For Accountants | Neat',
    description: 'Eliminated manual data entry and manage your clients receipts, invoices, and tax documents in one easy-to-use, paperless platform. Get a free demo.',
    canonical: `${APP_URL}/accountants/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/accountants/`,
      type: 'article',
      article: {
        modifiedTime: '2023-04-23T16:34:01+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/accountants/#webpage`,
        url: `${APP_URL}/accountants/`,
        name: 'Automated Bookkeeping Software For Accountants | Neat',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2019-05-04T11:30:50+00:00',
        dateModified: '2023-04-23T16:34:01+00:00',
        description: 'Eliminated manual data entry and manage your clients receipts, invoices, and tax documents in one easy-to-use, paperless platform. Get a free demo.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Accountants', item: `${APP_URL}/accountants/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/accountants/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/accountants/#primaryimage' },
      },
    },
    uri: '/accountants/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '27 minutes',
      },
    ],
  },
  accountingTerms: {
    title: 'Automated Bookkeeping Software For Accountants | Neat',
    description: 'We all know that jargon blocks your ability to understand information. (And everybusiness owner who\'s worked with an accountant said, "Amen!")',
    canonical: `${APP_URL}/accounting-terms/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/accounting-terms/`,
      type: 'article',
      article: {
        modifiedTime: '2022-05-11T19:56:46+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/accounting-terms/#webpage`,
        url: `${APP_URL}/accounting-terms/`,
        name: '56 Accounting Terms Defined | Neat',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2021-07-15T18:28:23+00:00',
        dateModified: '2022-05-11T19:56:46+00:00',
        description: 'We all know that jargon blocks your ability to understand information. (And everybusiness owner who\'s worked with an accountant said, "Amen!")',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Accounting Terms', item: `${APP_URL}/accounting-terms/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/accounting-terms/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/accounting-terms/#primaryimage' },
      },
    },
    uri: '/accounting-terms/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '32 minutes',
      },
    ],
  },
  automatedInsights: {
    title: 'Automated Expense Tracking Software & Reporting by Neat',
    description: 'Simplify Bookkeeping With Neat\'s Automated Expense Tracking Software—Manage Receipts, Monitor Expenses, And Gain Real-Time Financial Insights Effortlessly.',
    canonical: `${APP_URL}/automated-insights/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/automated-insights/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:32:47+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/automated-insights/#webpage`,
        url: `${APP_URL}/automated-insights/`,
        name: 'Automated Expense Tracking Software & Reporting by Neat',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2022-10-21T18:10:23+00:00',
        dateModified: '2023-02-03T20:32:47+00:00',
        description: 'Simplify Bookkeeping With Neat\'s Automated Expense Tracking Software—Manage Receipts, Monitor Expenses, And Gain Real-Time Financial Insights Effortlessly.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Automated Insights', item: `${APP_URL}/automated-insights/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/automated-insights/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/automated-insights/#primaryimage' },
      },
    },
    uri: '/automated-insights/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '11 minutes',
      },
    ],
  },
  balanceSheetTemplate: {
    title: 'Balance Sheet Template | The Neat Company',
    description: 'We\'ve built this free balance sheet template to help you manage your numbers quickly and easily.',
    canonical: `${APP_URL}/balance-sheet-template/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/balance-sheet-template/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:45:22+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/balance-sheet-template/#webpage`,
        url: `${APP_URL}/balance-sheet-template/`,
        name: 'Balance Sheet Template | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2022-10-21T18:10:23+00:00',
        dateModified: '2023-02-03T20:32:47+00:00',
        description: 'Simplify bookkeeping with Neat\'s mobile accounting software & storage. Automate reports, gain business insights, manage receipts & expenses. Try for free.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Balance Sheet Template', item: `${APP_URL}/balance-sheet-template/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/balance-sheet-template/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/balance-sheet-template/#primaryimage' },
      },
    },
    uri: '/balance-sheet-template/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '16 minutes',
      },
    ],
  },
  blog: {
    title: 'Resources for Small Businesses | The Neat Company',
    description: 'The Neat Blog provides articles and how tos on accounting, bookkeeping, and other topics relevant to small business owners.',
    canonical: `${APP_URL}/blog/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/blog/`,
      type: 'article',
      article: {
        modifiedTime: '2022-03-21T20:22:25+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/blog/#webpage`,
        url: `${APP_URL}/blog/`,
        name: 'Resources for Small Businesses | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2019-08-15T17:58:59+00:00',
        dateModified: '2022-03-21T20:22:25+00:00',
        description: 'The Neat Blog provides articles and how tos on accounting, bookkeeping, and other topics relevant to small business owners.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Blog Home Page', item: `${APP_URL}/blog/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/blog/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/blog/#primaryimage' },
      },
    },
    uri: '/blog/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '7 minutes',
      },
    ],
  },
  careers: {
    title: 'Careers | The Neat Company',
    description: 'Neat is a highly collaborative environment geared towards creative problem solving and rapid decision making. Explore careers at Neat.',
    canonical: `${APP_URL}/careers/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/careers/`,
      type: 'article',
      article: {
        modifiedTime: '2022-09-07T13:30:13+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/careers/#webpage`,
        url: `${APP_URL}/careers/`,
        name: 'Careers | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2019-07-01T18:25:20+00:00',
        dateModified: '2022-09-07T13:30:13+00:00',
        description: 'Neat is a highly collaborative environment geared towards creative problem solving and rapid decision making. Explore careers at Neat.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Careers', item: `${APP_URL}/careers/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/careers/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/careers/#primaryimage' },
      },
    },
    uri: '/careers/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '15 minutes',
      },
    ],
  },
  deleteAccount: { seo: {} },
  emailPreferences: {
    title: 'Email Preferences | The Neat Company',
    canonical: `${APP_URL}/email-preferences/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/email-preferences/`,
      type: 'article',
      article: {
        modifiedTime: '2022-03-21T18:34:41+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/email-preferences/#webpage`,
        url: `${APP_URL}/email-preferences/`,
        name: 'Email Preferences | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2019-09-18T13:07:26+00:00',
        dateModified: '2022-03-21T18:34:41+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Email Preferences', item: `${APP_URL}/email-preferences/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/email-preferences/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/careers/#primaryimage' },
      },
    },
    uri: '/email-preferences/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '5 minutes',
      },
    ],
  },
  fbRenew: {
    title: 'The Neat Company: Smarter receipt and document management',
    description: 'Transform the way you manage and organize your home or business. Unlimited file and document storage, expense tracking, bank-level encryption, and more! Try for free.',
    canonical: `${APP_URL}/fb-renew/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/fb-renew/`,
      type: 'article',
      article: {
        modifiedTime: '2023-03-29T13:34:24+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/fb-renew/#webpage`,
        url: `${APP_URL}/fb-renew/`,
        name: 'The Neat Company: Smarter receipt and document management',
        description: 'Transform the way you manage and organize your home or business. Unlimited file and document storage, expense tracking, bank-level encryption, and more! Try for free.',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2023-03-23T18:22:01+00:00',
        dateModified: '2023-03-29T13:34:24+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Renew', item: `${APP_URL}/fb-renew/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/fb-renew/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/fb-renew/#primaryimage' },
      },
    },
    uri: '/fb-renew/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '6 minutes',
      },
    ],
  },
  home: {
    title: 'The Neat Company: Scanner, Receipt & Document Management',
    description: 'Scan, Store, and Simplify Your Finances with Neat Scanner & Document Management App.',
    canonical: `${APP_URL}/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/`,
      type: 'article',
      article: {
        modifiedTime: '2023-03-02T19:09:24+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/#webpage`,
        url: `${APP_URL}/`,
        name: 'The Neat Company: Scanner, Receipt & Document Management',
        description: 'Scan, Store, and Simplify Your Finances with Neat Scanner & Document Management App.',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2022-10-14T20:00:10+00:00',
        dateModified: '2023-03-02T19:09:24+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/#primaryimage' },
      },
    },
    uri: '/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '20 minutes',
      },
    ],
  },
  incomeStatementTemplate: {
    title: 'Income Statement Template | The Neat Company',
    description: 'This free Excel template is editable and is a great way to compare your income year over year.',
    canonical: `${APP_URL}/income-statement-template/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/income-statement-template/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:44:36+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/income-statement-template/#webpage`,
        url: `${APP_URL}/income-statement-template/`,
        name: 'Income Statement Template | The Neat Company',
        description: 'This free Excel template is editable and is a great way to compare your income year over year.',
        isPartOf: { '@id': `${APP_URL}/income-statement-template/#website` },
        datePublished: '2021-10-27T19:09:07+00:00',
        dateModified: '2023-02-03T20:44:36+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Income Statement Template', item: `${APP_URL}/income-statement-template/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/income-statement-template/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/income-statement-template/#primaryimage' },
      },
    },
    uri: '/income-statement-template',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '17 minutes',
      },
    ],
  },
  integrateSeamlesslyWithQuickbooks: {
    title: 'Integrate with QuickBooks | Small Business Accounting Software | Neat',
    description: 'Using Neat with QuickBooks Online or QuickBooks Desktop simplifies accounting by reducing data entry and automatically organizing expenses.',
    canonical: `${APP_URL}/integrate-seamlessly-with-quickbooks/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/integrate-seamlessly-with-quickbooks/`,
      type: 'article',
      article: {
        modifiedTime: '2021-08-25T15:06:10+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/integrate-seamlessly-with-quickbooks/#webpage`,
        url: `${APP_URL}/integrate-seamlessly-with-quickbooks/`,
        name: 'Integrate with QuickBooks | Small Business Accounting Software | Neat',
        description: 'Using Neat with QuickBooks Online or QuickBooks Desktop simplifies accounting by reducing data entry and automatically organizing expenses.',
        isPartOf: { '@id': `${APP_URL}/integrate-seamlessly-with-quickbooks/#website` },
        datePublished: '2020-06-30T14:17:47+00:00',
        dateModified: '2021-08-25T15:06:10+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Integrate with QuickBooks', item: `${APP_URL}/integrate-seamlessly-with-quickbooks/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/integrate-seamlessly-with-quickbooks/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integrate-seamlessly-with-quickbooks/#primaryimage' },
      },
    },
    uri: '/integrate-seamlessly-with-quickbooks',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '10 minutes',
      },
    ],
  },
  integrations: {
    title: 'Receipt Scanner with Tax Integration by Neat',
    description: 'Neat\'s receipt scanner with tax integration simplifies expense tracking and tax prep with seamless software connections.',
    canonical: `${APP_URL}/integrations/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/integrations/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:39:44+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/integrations/#webpage`,
        url: `${APP_URL}/integrations/`,
        name: 'Receipt Scanner with Tax Integration by Neat',
        description: 'Neat\'s receipt scanner with tax integration simplifies expense tracking and tax prep with seamless software connections.',
        isPartOf: { '@id': `${APP_URL}/integrations/#website` },
        datePublished: '2019-05-13T20:34:05+00:00',
        dateModified: '2023-02-03T20:39:44+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Integrations', item: `${APP_URL}/integrations/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/integrations/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integrations/#primaryimage' },
      },
    },
    uri: '/integrations',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '10 minutes',
      },
    ],
  },
  integrationSupport: {
    title: 'Receipt & Invoice Management Software Integrations | Neat',
    description: 'Neat extracts data from scanned receipts, invoices, and other documents and sends them to popular accounting, tax, and email software. Try free for 30 days.',
    canonical: `${APP_URL}/integration-support/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/integration-support/`,
      type: 'article',
      article: {
        modifiedTime: '2020-01-29T15:49:01+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/integration-support/#webpage`,
        url: `${APP_URL}/integration-support/`,
        name: 'Receipt & Invoice Management Software Integrations | Neat',
        description: 'Neat extracts data from scanned receipts, invoices, and other documents and sends them to popular accounting, tax, and email software. Try free for 30 days.',
        isPartOf: { '@id': `${APP_URL}/integration-support/#website` },
        datePublished: '2019-12-16T21:14:34+00:00',
        dateModified: '2020-01-29T15:49:01+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Integrations Support &#8211; Partner Page', item: `${APP_URL}/integration-support/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/integration-support/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integration-support/#primaryimage' },
      },
    },
    uri: '/integration-support',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '15 minutes',
      },
    ],
  },
  invoiceTemplate: {
    title: 'Receipt & Invoice Management Software Integrations | Neat',
    description: 'Neat extracts data from scanned receipts, invoices, and other documents and sends them to popular accounting, tax, and email software. Try free for 30 days.',
    canonical: `${APP_URL}/invoice-template/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/invoice-template/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:43:44+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/invoice-template/#webpage`,
        url: `${APP_URL}/invoice-template/`,
        name: 'Free Invoice Template | The Neat Company',
        description: 'Neat extracts data from scanned receipts, invoices, and other documents and sends them to popular accounting, tax, and email software. Try free for 30 days.',
        isPartOf: { '@id': `${APP_URL}/invoice-template/#website` },
        datePublished: '2021-10-12T19:58:53+00:00',
        dateModified: '2023-02-03T20:43:44+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Free Invoice Template', item: `${APP_URL}/invoice-template/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/invoice-template/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integration-support/#primaryimage' },
      },
    },
    uri: '/invoice-template',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '44 minutes',
      },
    ],
  },
  neatvault: {
    title: 'The Neat Company: Small business finances made easy',
    description: 'Simplify bookkeeping with Neat\'s mobile accounting software & storage. Automate reports, gain business insights, manage receipts & expenses. Try for free.',
    canonical: `${APP_URL}/neatvault/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/neatvault/`,
      type: 'article',
      article: {
        modifiedTime: '2022-10-04T18:37:18+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/neatvault/#webpage`,
        url: `${APP_URL}/neatvault/`,
        name: 'NeatVault | The Neat Company',
        description: 'Simplify bookkeeping with Neat\'s mobile accounting software & storage. Automate reports, gain business insights, manage receipts & expenses. Try for free.',
        isPartOf: { '@id': `${APP_URL}/neatvault/#website` },
        datePublished: '2022-09-23T20:41:38+00:00',
        dateModified: '2022-10-04T18:37:18+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'NeatVault', item: `${APP_URL}/neatvault/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/neatvault/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integration-support/#primaryimage' },
      },
    },
    uri: '/neatvault',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '10 minutes',
      },
    ],
  },
  offerNeatvault: {
    title: 'NeatVault | The Neat Company',
    description: 'Track invoices and payments all in one place to keep organization simple.',
    canonical: `${APP_URL}/offer-neatvault/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/offer-neatvault/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:53:19+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/offer-neatvault/#webpage`,
        url: `${APP_URL}/offer-neatvault/`,
        name: 'NeatVault | The Neat Company',
        description: 'Track invoices and payments all in one place to keep organization simple.',
        isPartOf: { '@id': `${APP_URL}/offer-neatvault/#website` },
        datePublished: '2022-11-15T15:44:57+00:00',
        dateModified: '2023-02-03T20:53:19+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'NeatVault', item: `${APP_URL}/offer-neatvault/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/offer-neatvault/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integration-support/#primaryimage' },
      },
    },
    uri: '/offer-neatvault',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '10 minutes',
      },
    ],
  },
  ourHistory: {
    title: 'Our History | Neat',
    description: 'Our vision is to accelerate small businesses\' transition to a world where keeping books is simple, frictionless, instant, and automated.',
    canonical: `${APP_URL}/our-history/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/our-history/`,
      type: 'article',
      article: {
        modifiedTime: '2022-10-31T16:53:00+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/our-history/#webpage`,
        url: `${APP_URL}/our-history/`,
        name: 'Our History | Neat',
        description: 'Our vision is to accelerate small businesses\' transition to a world where keeping books is simple, frictionless, instant, and automated.',
        isPartOf: { '@id': `${APP_URL}/our-history/#website` },
        datePublished: '2019-06-28T14:43:25+00:00',
        dateModified: '2022-10-31T16:53:00+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Our History', item: `${APP_URL}/our-history/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/our-history/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integration-support/#primaryimage' },
      },
    },
    uri: '/our-history',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '24 minutes',
      },
    ],
  },
  policies: {
    title: 'Neat Policies | The Neat Company',
    canonical: `${APP_URL}/policies/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/policies/`,
      type: 'article',
      article: {
        modifiedTime: '2022-03-30T19:58:37+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/policies/#webpage`,
        url: `${APP_URL}/policies/`,
        name: 'Neat Policies | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/policies/#website` },
        datePublished: '2019-10-04T13:34:48+00:00',
        dateModified: '2022-03-30T19:58:37+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Neat Policies', item: `${APP_URL}/policies/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/policies/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integration-support/#primaryimage' },
      },
    },
    uri: '/policies',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '9 minutes',
      },
    ],
  },
  pricing: {
    title: 'Neat Pricing & Subscription Plans',
    description: 'Discover Neat pricing options for receipt scanning and document management. Learn about subscription costs, free trials, and options.',
    canonical: `${APP_URL}/pricing/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/pricing/`,
      type: 'article',
      article: {
        modifiedTime: '2023-03-13T15:51:09+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/pricing/#webpage`,
        url: `${APP_URL}/pricing/`,
        name: 'Neat Pricing & Subscription Plans',
        description: 'Discover Neat pricing options for receipt scanning and document management. Learn about subscription costs, free trials, and options.',
        isPartOf: { '@id': `${APP_URL}/pricing/#website` },
        datePublished: '2022-11-04T22:43:05+00:00',
        dateModified: '2023-03-13T15:51:09+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Pricing' },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/pricing/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integration-support/#primaryimage' },
      },
    },
    uri: '/pricing',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '7 minutes',
      },
    ],
  },
  migrationSupport: {
    title: 'Migration Support | Neat | Smarter receipt and document management',
    description: 'Simplify bookkeeping with Neat\'s mobile accounting software & storage. Automate reports, gain business insights, manage receipts & expenses. Try for free.',
    canonical: `${APP_URL}/migration-support/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/migration-support/`,
      type: 'article',
      article: {
        modifiedTime: '2023-03-13T15:51:09+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/migration-support/#webpage`,
        url: `${APP_URL}/migration-support/`,
        name: 'Migration Support | Neat | Smarter receipt and document management',
        description: 'Simplify bookkeeping with Neat\'s mobile accounting software & storage. Automate reports, gain business insights, manage receipts & expenses. Try for free.',
        isPartOf: { '@id': `${APP_URL}/migration-support/#website` },
        datePublished: '2022-11-04T22:43:05+00:00',
        dateModified: '2023-03-13T15:51:09+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Migration Support', item: `${APP_URL}/migration-support/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/migration-support/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integration-support/#primaryimage' },
      },
    },
    uri: '/migration-support',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '7 minutes',
      },
    ],
  },
  neatHomeVsExpensify: {
    title: 'Compare NeatHome vs Expensify',
    description: 'Simplify bookkeeping with Neat\'s mobile accounting software & storage. Automate reports, gain business insights, manage receipts & expenses. Try for free.',
    canonical: `${APP_URL}/neathome-vs-expensify/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/neathome-vs-expensify/`,
      type: 'article',
      article: {
        modifiedTime: '2023-03-13T15:51:09+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/neathome-vs-expensify/#webpage`,
        url: `${APP_URL}/neathome-vs-expensify/`,
        name: 'Compare NeatHome vs Expensify',
        description: 'Simplify bookkeeping with Neat\'s mobile accounting software & storage. Automate reports, gain business insights, manage receipts & expenses. Try for free.',
        isPartOf: { '@id': `${APP_URL}/neathome-vs-expensify/#website` },
        datePublished: '2022-11-04T22:43:05+00:00',
        dateModified: '2023-03-13T15:51:09+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'NeatHome vs. Expensify', item: `${APP_URL}/neathome-vs-expensify/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/neathome-vs-expensify/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integration-support/#primaryimage' },
      },
    },
    uri: '/neathome-vs-expensify',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '7 minutes',
      },
    ],
  },
  neatHomeVsMint: {
    title: 'Compare NeatHome vs Mint',
    description: 'Simplify bookkeeping with Neat\'s mobile accounting software & storage. Automate reports, gain business insights, manage receipts & expenses. Try for free.',
    canonical: `${APP_URL}/neathome-vs-mint/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/neathome-vs-mint/`,
      type: 'article',
      article: {
        modifiedTime: '2023-03-13T15:51:09+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/neathome-vs-mint/#webpage`,
        url: `${APP_URL}/neathome-vs-mint/`,
        name: 'Compare NeatHome vs Mint',
        description: 'Simplify bookkeeping with Neat\'s mobile accounting software & storage. Automate reports, gain business insights, manage receipts & expenses. Try for free.',
        isPartOf: { '@id': `${APP_URL}/neathome-vs-mint/#website` },
        datePublished: '2022-11-04T22:43:05+00:00',
        dateModified: '2023-03-13T15:51:09+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'NeatHome vs. Mint', item: `${APP_URL}/neathome-vs-mint/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/neathome-vs-mint/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integration-support/#primaryimage' },
      },
    },
    uri: '/neathome-vs-mint',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '7 minutes',
      },
    ],
  },
  privacy: {
    title: 'Privacy Policy | The Neat Company',
    canonical: `${APP_URL}/policies/privacy/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/policies/privacy/`,
      type: 'article',
      article: {
        modifiedTime: '2021-04-06T13:38:13+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/policies/privacy/#webpage`,
        url: `${APP_URL}/policies/privacy/`,
        name: 'Privacy Policy | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/policies/privacy/#website` },
        datePublished: '2019-07-11T19:31:47+00:00',
        dateModified: '2021-04-06T13:38:13+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Neat Policies', item: `{${APP_URL}/policies` },
            { '@type': 'ListItem', position: 3, name: 'Privacy Policy', item: `${APP_URL}/policies/privacy/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/policies/privacy/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/integration-support/#primaryimage' },
      },
    },
    uri: '/policies/privacy',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '18 minutes',
      },
    ],
  },
  productReleases: {
    title: 'Product Releases for Neat\'s Bookkeeping Software | The Neat Company',
    description: 'We\'re always looking to create the best experience possible. Here is you can find all of our latest product updates for Neat\'s solutions.',
    canonical: `${APP_URL}/product-releases/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/product-releases/`,
      type: 'article',
      article: {
        modifiedTime: '2022-08-17T16:26:11+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/product-releases/#webpage`,
        url: `${APP_URL}/product-releases/`,
        name: 'Product Releases for Neat\'s Bookkeeping Software | The Neat Company',
        description: 'We\'re always looking to create the best experience possible. Here is you can find all of our latest product updates for Neat\'s solutions.',
        isPartOf: { '@id': `${APP_URL}/product-releases/#website` },
        datePublished: '2020-07-10T18:38:46+00:00',
        dateModified: '2022-08-17T16:26:11+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Product Releases', item: `${APP_URL}/product-releases/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/product-releases/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/product-releases/#primaryimage' },
      },
    },
    uri: '/product-releases',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '94 minutes',
      },
    ],
  },
  receiptDocumentScanners: {
    title: 'Compatible Receipt and Document Scanners | Neat',
    description: 'Neat works with any TWAIN compliant scanner, which includes most scanners on the market today. Connecting these devices is covered as part of our plans.',
    canonical: `${APP_URL}/receipt-document-scanners/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/receipt-document-scanners/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:41:18+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/receipt-document-scanners/#webpage`,
        url: `${APP_URL}/receipt-document-scanners/`,
        name: 'Compatible Receipt and Document Scanners | Neat',
        description: 'Neat works with any TWAIN compliant scanner, which includes most scanners on the market today. Connecting these devices is covered as part of our plans.',
        isPartOf: { '@id': `${APP_URL}/receipt-document-scanners/#website` },
        datePublished: '2019-09-06T16:28:43+00:00',
        dateModified: '2023-02-03T20:41:18+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Compatible Scanners', item: `${APP_URL}/receipt-document-scanners/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/receipt-document-scanners/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/receipt-document-scanners/#primaryimage' },
      },
    },
    uri: '/receipt-document-scanners',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '17 minutes',
      },
    ],
  },
  referral: {
    title: 'Compatible Receipt and Document Scanners | Neat',
    description: 'Neat works with any TWAIN compliant scanner, which includes most scanners on the market today. Connecting these devices is covered as part of our plans.',
    canonical: `${APP_URL}/referral/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/referral/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-07T14:46:58+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/referral/#webpage`,
        url: `${APP_URL}/referral/`,
        name: 'Compatible Receipt and Document Scanners | Neat',
        description: 'Neat works with any TWAIN compliant scanner, which includes most scanners on the market today. Connecting these devices is covered as part of our plans.',
        isPartOf: { '@id': `${APP_URL}/referral/#website` },
        datePublished: '2022-12-08T20:25:25+00:00',
        dateModified: '2023-02-07T14:46:58+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Referral', item: `${APP_URL}/referral/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/referral/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/referral/#primaryimage' },
      },
    },
    uri: '/referral',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '3 minutes',
      },
    ],
  },
  referralTermsConditions: {
    title: 'Referral Terms and Conditions | The Neat Company',
    canonical: `${APP_URL}/referral-terms-conditions/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/referral-terms-conditions/`,
      type: 'article',
      article: {
        modifiedTime: '2023-03-30T16:01:58+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/referral-terms-conditions/#webpage`,
        url: `${APP_URL}/referral-terms-conditions/`,
        name: 'Referral Terms and Conditions | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/referral-terms-conditions/#website` },
        datePublished: '2023-03-30T15:15:20+00:00',
        dateModified: '2023-03-30T16:01:58+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Referral Terms and Conditions', item: `${APP_URL}/referral-terms-conditions/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/referral-terms-conditions/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/referral-terms-conditions/#primaryimage' },
      },
    },
    uri: '/referral-terms-conditions',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '4 minutes',
      },
    ],
  },
  renew: {
    title: 'The Neat Company: Smarter receipt and document management',
    description: 'Transform the way you manage and organize your home or business. Unlimited file and document storage, expense tracking, bank-level encryption, and more! Try for free.',
    canonical: `${APP_URL}/renew/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/renew/`,
      type: 'article',
      article: {
        modifiedTime: '2023-03-29T13:35:08+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/renew/#webpage`,
        url: `${APP_URL}/renew/`,
        name: 'The Neat Company: Smarter receipt and document management',
        description: 'Transform the way you manage and organize your home or business. Unlimited file and document storage, expense tracking, bank-level encryption, and more! Try for free.',
        isPartOf: { '@id': `${APP_URL}/renew/#website` },
        datePublished: '2023-01-20T14:11:31+00:00',
        dateModified: '2023-03-29T13:35:08+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Renew', item: `${APP_URL}/renew/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/renew/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/renew/#primaryimage' },
      },
    },
    uri: '/renew',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '6 minutes',
      },
    ],
  },
  policiesSalesTax: {
    title: 'Sales Tax Policy | The Neat Company',
    canonical: `${APP_URL}/policies/sales-tax/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/policies/sales-tax/`,
      type: 'article',
      article: {
        modifiedTime: '2023-03-01T15:33:53+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/policies/sales-tax/#webpage`,
        url: `${APP_URL}/policies/sales-tax/`,
        name: 'Sales Tax Policy | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/policies/sales-tax/#website` },
        datePublished: '2019-10-09T20:32:09+00:00',
        dateModified: '2023-03-01T15:33:53+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Neat Policies', item: `${APP_URL}/policies/` },
            { '@type': 'ListItem', position: 3, name: 'Sales Tax Policy', item: `${APP_URL}/policies/sales-tax/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/policies/sales-tax/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/policies/sales-tax/#primaryimage' },
      },
    },
    uri: '/policies/sales-tax',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '7 minutes',
      },
    ],
  },
  security: {
    title: 'Security Features | Neat',
    description: 'We employ best-in-class security features to keep your information protected and safe. Try free for 15 days. No credit card required.',
    canonical: `${APP_URL}/security/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/security/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:40:33+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/security/#webpage`,
        url: `${APP_URL}/security/`,
        name: 'Security Features | Neat',
        description: 'We employ best-in-class security features to keep your information protected and safe. Try free for 15 days. No credit card required.',
        isPartOf: { '@id': `${APP_URL}/security/#website` },
        datePublished: '2019-09-06T15:29:29+00:00',
        dateModified: '2023-02-03T20:40:33+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Security', item: `${APP_URL}/security/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/security/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/policies/security/#primaryimage' },
      },
    },
    uri: '/security',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '15 minutes',
      },
    ],
  },
  signUp: { seo: {} },
  taxPrep: {
    title: 'App to Scan Receipts for Taxes',
    description: 'Neat\'s app to scan receipts for taxes simplifies organization and maximizes deductions efficiently.',
    canonical: `${APP_URL}/tax-prep/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/tax-prep/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:39:04+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/tax-prep/#webpage`,
        url: `${APP_URL}/tax-prep/`,
        name: 'App to Scan Receipts for Taxes',
        description: 'Neat\'s app to scan receipts for taxes simplifies organization and maximizes deductions efficiently.',
        isPartOf: { '@id': `${APP_URL}/tax-prep/#website` },
        datePublished: '2019-08-26T18:09:07+00:00',
        dateModified: '2023-02-03T20:39:04+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Tax Preparation Features Page', item: `${APP_URL}/tax-prep/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/tax-prep/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/policies/tax-prep/#primaryimage' },
      },
    },
    uri: '/tax-prep',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '20 minutes',
      },
    ],
  },
  termsConditions: {
    title: 'Terms & Conditions | The Neat Company',
    canonical: `${APP_URL}/terms-conditions/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/terms-conditions/`,
      type: 'article',
      article: {
        modifiedTime: '2023-03-27T19:43:01+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/terms-conditions/#webpage`,
        url: `${APP_URL}/terms-conditions/`,
        name: 'Terms & Conditions | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/terms-conditions/#website` },
        datePublished: '2019-07-11T19:30:35+00:00',
        dateModified: '2023-03-27T19:43:01+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Terms &#038; Conditions', item: `${APP_URL}/terms-conditions/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/terms-conditions/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/policies/terms-conditions/#primaryimage' },
      },
    },
    uri: '/terms-conditions',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '18 minutes',
      },
    ],
  },
  trackReceipts: {
    title: 'Best Receipt Tracking App for Small Business | Neat',
    description: 'Ditch manual receipt tracking. Our receipt scanner app ensures accurate expense management for taxes. Digitize, categorize & simplify your finances.',
    canonical: `${APP_URL}/track-receipts/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/track-receipts/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:37:29+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/track-receipts/#webpage`,
        url: `${APP_URL}/track-receipts/`,
        name: 'Best Receipt Tracking App for Small Business | Neat',
        description: 'Ditch manual receipt tracking. Our receipt scanner app ensures accurate expense management for taxes. Digitize, categorize & simplify your finances.',
        isPartOf: { '@id': `${APP_URL}/track-receipts/#website` },
        datePublished: '2023-02-01T21:30:52+00:00',
        dateModified: '2023-02-03T20:37:29+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Track Receipts &#038; Invoices', item: `${APP_URL}/track-receipts/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/track-receipts/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/policies/track-receipts/#primaryimage' },
      },
    },
    uri: '/track-receipts',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '10 minutes',
      },
    ],
  },
  ultimateGuideReceiptScanningDocManagement: {
    title: 'The Ultimate Guide to Receipt Scanning, Expense Tracking & Document Management',
    description: 'Take control of your business finances. Our guide shows how to effortlessly organize receipts & expenses for stress-free tax prep and budgeting.',
    canonical: `${APP_URL}/ultimate-guide-receipt-scanning-expense-tracking-document-management/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/ultimate-guide-receipt-scanning-expense-tracking-document-management/`,
      type: 'article',
      article: {
        modifiedTime: '2025-06-08T20:37:29+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/ultimate-guide-receipt-scanning-expense-tracking-document-management/#webpage`,
        url: `${APP_URL}/ultimate-guide-receipt-scanning-expense-tracking-document-management/`,
        name: 'The Ultimate Guide to Receipt Scanning, Expense Tracking & Document Management',
        description: 'Take control of your business finances. Our guide shows how to effortlessly organize receipts & expenses for stress-free tax prep and budgeting.',
        isPartOf: { '@id': `${APP_URL}/ultimate-guide-receipt-scanning-expense-tracking-document-management/#website` },
        datePublished: '2025-06-08T21:30:52+00:00',
        dateModified: '2025-06-08T20:37:29+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'The Ultimate Guide', item: `${APP_URL}/ultimate-guide-receipt-scanning-expense-tracking-document-management/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/ultimate-guide-receipt-scanning-expense-tracking-document-management/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/policies/ultimate-guide-receipt-scanning-expense-tracking-document-management/#primaryimage' },
      },
    },
    uri: '/ultimate-guide-receipt-scanning-expense-tracking-document-management',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '10 minutes',
      },
    ],
  },
  twelveDaysOfNeat: {
    title: '12 Days of Neat - Holiday Offers',
    description: 'Neat\'s invoice and receipt tracker helps businesses store and organize financial documents with their scanner or mobile phone. Try free for 15 days.',
    canonical: `${APP_URL}/12-days-of-neat/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/12-days-of-neat/`,
      type: 'article',
      article: {
        modifiedTime: '2024-12-06T20:37:29+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/12-days-of-neat/#webpage`,
        url: `${APP_URL}/12-days-of-neat/`,
        name: '12 Days of Neat - Holiday Offers',
        description: 'Neat\'s invoice and receipt tracker helps businesses store and organize financial documents with their scanner or mobile phone. Try free for 15 days.',
        isPartOf: { '@id': `${APP_URL}/12-days-of-neat/#website` },
        datePublished: '2024-12-06T21:30:52+00:00',
        dateModified: '2024-12-06T20:37:29+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: '12 Days of Neat', item: `${APP_URL}/12-days-of-neat/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/12-days-of-neat/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/policies/12-days-of-neat/#primaryimage' },
      },
    },
    uri: '/12-days-of-neat',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '10 minutes',
      },
    ],
  },
  expenseManagementMobileApp: {
    title: 'Expense Tracker App to Organize Digital Receipts & Documents',
    description: 'Neat\'s expense tracker app helps organize digital receipts effortlessly for easy expense management and tax preparation.',
    canonical: `${APP_URL}/expense-management-mobile-app/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/expense-management-mobile-app/`,
      type: 'article',
      article: {
        modifiedTime: '2024-12-06T20:37:29+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/expense-management-mobile-app/#webpage`,
        url: `${APP_URL}/expense-management-mobile-app/`,
        name: 'Expense Tracker App to Organize Digital Receipts & Documents',
        description: 'Neat\'s expense tracker app helps organize digital receipts effortlessly for easy expense management and tax preparation.',
        isPartOf: { '@id': `${APP_URL}/expense-management-mobile-app/#website` },
        datePublished: '2024-12-16T21:30:52+00:00',
        dateModified: '2024-12-16T20:37:29+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Expense Management Mobile App', item: `${APP_URL}/expense-management-mobile-app/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/expense-management-mobile-app/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/policies/expense-management-mobile-app/#primaryimage' },
      },
    },
    uri: '/expense-management-mobile-app',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '10 minutes',
      },
    ],
  },
  neatVsExpensify: {
    title: 'Neat VS Expensify | Neat',
    description: 'Neat\'s invoice and receipt tracker helps businesses store and organize financial documents with their scanner or mobile phone. Try free for 15 days.',
    canonical: `${APP_URL}/neat-vs-expensify/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/neat-vs-expensify/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:37:29+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/neat-vs-expensify/#webpage`,
        url: `${APP_URL}/neat-vs-expensify/`,
        name: 'Neat VS Expensify | Neat',
        description: 'Neat VS Expensify',
        isPartOf: { '@id': `${APP_URL}/neat-vs-expensify/#website` },
        datePublished: '2023-02-01T21:30:52+00:00',
        dateModified: '2023-02-03T20:37:29+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Neat VS Expensify', item: `${APP_URL}/neat-vs-expensify/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/neat-vs-expensify/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/policies/neat-vs-expensify/#primaryimage' },
      },
    },
    uri: '/neat-vs-expensify',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '10 minutes',
      },
    ],
  },
  transactionStreaming: {
    title: 'Reconciliation Software with Document Matching',
    description: 'Looking for reconciliation software with document matching? Neat helps small businesses match transactions, receipts, and invoices for accurate bookkeeping.',
    canonical: `${APP_URL}/transaction-streaming/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/transaction-streaming/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:38:16+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/transaction-streaming/#webpage`,
        url: `${APP_URL}/transaction-streaming/`,
        name: 'Reconciliation Software with Document Matching',
        description: 'Looking for reconciliation software with document matching? Neat helps small businesses match transactions, receipts, and invoices for accurate bookkeeping.',
        isPartOf: { '@id': `${APP_URL}/transaction-streaming/#website` },
        datePublished: '2019-09-25T18:39:23+00:00',
        dateModified: '2023-02-03T20:38:16+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Transaction Matching &#038; Streaming', item: `${APP_URL}/transaction-streaming/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/transaction-streaming/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/transaction-streaming/tax-prep/#primaryimage' },
      },
    },
    uri: '/transaction-streaming',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '16 minutes',
      },
    ],
  },
  vipService: {
    title: 'VIP Service | Neat | Dedicated and priority support',
    description: 'Simplify bookkeeping with Neat\'s mobile accounting software & storage. Automate reports, gain business insights, manage receipts & expenses. Try for free.',
    canonical: `${APP_URL}/vip-service/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/vip-service/`,
      type: 'article',
      article: {
        modifiedTime: '2023-02-03T20:33:39+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/vip-service/#webpage`,
        url: `${APP_URL}/vip-service/`,
        name: 'VIP Service | Neat | Dedicated and priority support',
        description: 'Simplify bookkeeping with Neat\'s mobile accounting software & storage. Automate reports, gain business insights, manage receipts & expenses. Try for free.',
        isPartOf: { '@id': `${APP_URL}/vip-service/#website` },
        datePublished: '2022-10-21T18:27:45+00:00',
        dateModified: '2023-02-03T20:33:39+00:00',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'VIP Service', item: `${APP_URL}/vip-service/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/vip-service/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/vip-service/tax-prep/#primaryimage' },
      },
    },
    uri: '/vip-service',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '15 minutes',
      },
    ],
  },
  webinars: {
    title: 'Webinars and Replays | The Neat Company',
    description: 'Access on-demand Neat webinars for exclusive tips and tricks, unlocking the full potential of Neat.',
    canonical: `${APP_URL}/webinars/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/webinars/`,
      type: 'article',
      article: {
        modifiedTime: '2023-09-26T18:10:23+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/webinars/#webpage`,
        url: `${APP_URL}/webinars/`,
        name: 'Webinars and Replays | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2023-09-26T18:10:23+00:00',
        dateModified: '2023-09-26T18:10:23+00:00',
        description: 'Access on-demand Neat webinars for exclusive tips and tricks, unlocking the full potential of Neat.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Webinars', item: `${APP_URL}/webinars/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/webinars/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/webinars/#primaryimage' },
      },
    },
    uri: '/webinars/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '11 minutes',
      },
    ],
  },
  freeTrial: {
    title: 'Free trial with no credit card | The Neat Company',
    description: 'Free trial with no credit card',
    canonical: `${APP_URL}/free-trial/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/free-trial/`,
      type: 'article',
      article: {
        modifiedTime: '2023-12-23T18:10:23+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/free-trial/#webpage`,
        url: `${APP_URL}/free-trial/`,
        name: 'Free trial with no credit card | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2023-12-23T18:10:23+00:00',
        dateModified: '2023-12-23T18:10:23+00:00',
        description: 'Free trial with no credit card',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Free Trial', item: `${APP_URL}/free-trial/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/free-trial/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/free-trial/#primaryimage' },
      },
    },
    uri: '/free-trial/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '11 minutes',
      },
    ],
  },
  digitalFilingCabinet: {
    title: 'Digital Filing Cabinet | The Neat Company',
    description: 'Start a paperless lifestyle and organize all of your documents in a safe & secured cloud based app platform.',
    canonical: `${APP_URL}/digital-filing-cabinet/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/digital-filing-cabinet/`,
      type: 'article',
      article: {
        modifiedTime: '2025-04-11T18:10:23+00:00',
      },
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/digital-filing-cabinet/#webpage`,
        url: `${APP_URL}/digital-filing-cabinet/`,
        name: 'Digital Filing Cabinet | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/#website` },
        datePublished: '2025-04-11T18:10:23+00:00',
        dateModified: '2025-04-11T18:10:23+00:00',
        description: 'Start a paperless lifestyle and organize all of your documents in a safe & secured cloud based app platform.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Digital Filing Cabinet', item: `${APP_URL}/digital-filing-cabinet/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/digital-filing-cabinet/`] }],
        primaryImageOfPage: { '@id': 'https://www.neat.com/digital-filing-cabinet/#primaryimage' },
      },
    },
    uri: '/digital-filing-cabinet/',
    additionalMetaTags: [
      {
        property: 'article:publisher',
        content: 'https://www.facebook.com/NeatCompany/',
      },
      {
        name: 'twitter:label1',
        content: 'Est. reading time',
      },
      {
        name: 'twitter:data1',
        content: '11 minutes',
      },
    ],
  },
  sweetDeal: {
    title: 'Save $100 Off All Buy Now Plans',
  },
  trackReceiptsTrial: {
    title: 'Neat Receipt Scanner App',
  },
  newsletter: {
    title: 'Neat Monthly Newsletter | The Neat Company',
    description: 'Product updates, bookkeeping insights, and upcoming webinars - delivered once a month. Subscribe to the Neat Monthly Newsletter.',
    canonical: `${APP_URL}/newsletter/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/newsletter/`,
      type: 'website',
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/newsletter/#webpage`,
        url: `${APP_URL}/newsletter/`,
        name: 'Neat Monthly Newsletter | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/#website` },
        description: 'Product updates, bookkeeping insights, and upcoming webinars - delivered once a month.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Newsletter', item: `${APP_URL}/newsletter/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/newsletter/`] }],
      },
    },
  },
  newsletterArchive: {
    title: 'Newsletter Archive | The Neat Company',
    description: 'Browse all past issues of the Neat Monthly Newsletter. Product updates, bookkeeping insights, and webinar announcements.',
    canonical: `${APP_URL}/newsletter/archive/`,
    twitter: {
      cardType: 'summary_large_image',
    },
    openGraph: {
      url: `${APP_URL}/newsletter/archive/`,
      type: 'website',
    },
    jsonLD: {
      webPage: {
        id: `${APP_URL}/newsletter/archive/#webpage`,
        url: `${APP_URL}/newsletter/archive/`,
        name: 'Newsletter Archive | The Neat Company',
        isPartOf: { '@id': `${APP_URL}/#website` },
        description: 'Browse all past issues of the Neat Monthly Newsletter.',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: APP_URL },
            { '@type': 'ListItem', position: 2, name: 'Newsletter', item: `${APP_URL}/newsletter/` },
            { '@type': 'ListItem', position: 3, name: 'Archive', item: `${APP_URL}/newsletter/archive/` },
          ],
        },
        inLanguage: 'en-US',
        potentialAction: [{ '@type': 'ReadAction', target: [`${APP_URL}/newsletter/archive/`] }],
      },
    },
  },
}
